export default __webpack_public_path__ + "media/images/help-3ae446edf3afab8a50e2216736ad8dc2.svg";